import React from "react"
import Container, { type ContainerProps } from "./Container"
import { twMerge } from "tailwind-merge"

// we can expand this as needed, but for now the prop interface is the same so lets keep
// it as an empty extension
export interface RowContainerProps extends ContainerProps {}

const defaultStyles = "flex-row space-x-5"

/**
 * RowContainer component.
 *
 * This component renders a Container component with row-oriented styles.
 *
 * @component
 * @param {RowContainerProps} props The properties for the component.
 * @returns {React.ReactNode} The rendered container element.
 */
const RowContainer = React.forwardRef<HTMLDivElement, RowContainerProps>(
  function Row({ children, styleOverrides, ...props }, ref) {
    const className = twMerge(defaultStyles, styleOverrides)

    return (
      <Container ref={ref} styleOverrides={className} {...props}>
        {children}
      </Container>
    )
  },
)

RowContainer.displayName = "RowContainer"

export default RowContainer
